class ImageController {
  constructor() {
    this.inputInfo = {};
    this.inputElement = document.createElement('input');
    this.controller = null;
    this.initScale = 1;
    this.minScale = 1;
    this.maxScale = 1;
    this.dialog = document.createElement('div');
    this.canvas = document.createElement('canvas');
    this.initDialog();
  }
  initDialog() {
    const dialogHtml = `
      <div class="personalize-photo-dialog">
        <h1>Photo crop</h1>
        <canvas data-input-info-id="" class="personalize_controller" width="375" height="375"></canvas>
        <p class="controller-btnGroups">
          <button type="button" class="clear btn" title="clear">
            <b class="hidden">clear</b>
          </button>
          <button type="button" class="scaleLarge scale btn" title="scale large">
            <b class="hidden">scale large</b>
          </button>
          <button type="button" class="scaleSmall scale btn" title="scale small">
            <b class="hidden">scale small</b>
          </button>
          <button type="button" class="angleLeft angle btn" title="angle left">
            <b class="hidden">angle left</b>
          </button>
          <button type="button" class="angleRight angle btn" title="angle right">
            <b class="hidden">angle right</b>
          </button>    
          <button type="button" class="confirm btn" title="confirm">
            <b class="hidden">confirm</b>
          </button>
        </p>
      </div>`;
      const dialogDom = document.createElement('div');
      dialogDom.classList.add('controller-box');
      dialogDom.classList.add('personalize-photo-mask');
      dialogDom.innerHTML = dialogHtml;
      document.body.appendChild(dialogDom);
      this.dialog = dialogDom;
      this.canvas = dialogDom.querySelector('canvas');
  }
  initController (inputElement, inputInfo) { 
    this.inputElement = inputElement;
    this.inputInfo = inputInfo;
    if (fabric) {
      this.controller = new fabric.Canvas(this.canvas, {
        controlsAboveOverlay: true,
        selection: false,
        crossOrigin: 'anonymous'
      }) ;
      this.renderController()
    }
  }
  renderController () {
    const fileInput = this.inputElement;
    const { width_percent, height_percent, shape } = this.inputInfo;
    const controller = this.controller;
    const width = controller.width - 4;
    const height = controller.height - 4;
    const scaleRatio = Math.min(1 / width_percent, 1 / height_percent);
    let boxWidth = width * width_percent * scaleRatio,
      boxHeight = height * height_percent * scaleRatio;
    console.log('widthScale', boxWidth, boxHeight, width_percent, height_percent);
    // 检查是否选择了文件
    if (fileInput.files.length > 0) {
      controller.clear();
      const selectedFile = fileInput.files[0];
      let clippath;
      if (shape === 2) {
        clippath = new fabric.Circle({
          radius: Math.max(boxWidth, boxHeight) / 2 - 2,
          fill: 'transparent',
          originX: 'center', originY: 'center',
          absolutePositioned: true,
          hasControls: false,
          selectable: false,
          top: boxWidth / 2 + 5,
          left: boxHeight / 2 + 5,
        });
        controller.add(new fabric.Circle({
          radius: Math.max(boxWidth, boxHeight) / 2,
          fill: 'transparent',
          absolutePositioned: true,
          originX: 'center', originY: 'center',
          hasControls: false,
          selectable: false,
          top: boxWidth / 2 + 5,
          left: boxHeight / 2 + 5,
          strokeWidth: 4,  // 设置边框宽度
          stroke: '#ae0a09',   // 设置边框颜色
        }));
      } else {
        clippath = new fabric.Rect({
          left: controller.width / 2,
          top: controller.height / 2,
          originX: 'center', originY: 'center',
          width: boxWidth - 4,
          height: boxHeight - 4,
          absolutePositioned: true,
          id: 'chilpath'
        });
        controller.add(new fabric.Rect({
          left: controller.width / 2,
          top: controller.height / 2,
          originX: 'center', originY: 'center',
          width: boxWidth,
          height: boxHeight,
          fill: 'transparent',
          absolutePositioned: true,
          // padding: 10,
          hasControls: false,
          selectable: false,
          strokeWidth: 4,  // 设置边框宽度
          stroke: '#ae0a09',   // 设置边框颜色
        }));
      }
      // 使用 Fabric.js 的 fabric.Image.fromURL 加载图片到画布
      fabric.Image.fromURL(URL.createObjectURL(selectedFile), (img) => {
        // 设置图片的位置、大小等属性
        img.scaleToWidth(boxWidth * 1);
        img.scaleToHeight(boxHeight * 1);
        img.clipPath = clippath;
        controller._selfClippath = clippath;
        img.set({
          left: controller.width / 2,
          top: controller.height / 2,
          originX: 'center', originY: 'center',
          crossOrigin: 'anonymous',
          transparentCorners: false,
        });
        img.setControlsVisibility({
          ml: false,
          mr: false,
          mt: false,
          mb: false
        });
        this.initScale = Math.max(img.scaleX, img.scaleY);
        this.minScale = calculateRepeatedSubtraction(Math.max(img.scaleX, img.scaleY));
        this.maxScale = calculateRepeatedSubtraction(Math.max(img.scaleX, img.scaleY), true);
        controller.add(img);
        controller.setActiveObject(img);
        controller.renderAll();
        this.controllerClipPath();
      }, {crossOrigin: 'anonymous'});
      this.showController();
    }
  }

  controllerClipPath (isClear=false) {
    const controller = this.controller;
    const clippath = controller._selfClippath;
    const clippathWidth = clippath.width;
    const left = (controller.width - clippathWidth) / 2;
    const top = (controller.height - clippath.height) / 2;
    if(!isClear) {
      const croppedImageData = controller.toDataURL({
        format: 'png',  // 选择输出格式，可以是 'png'、'jpeg' 等
        left: left,  // 设置导出区域的左上角坐标
        top: top,
        width: clippathWidth,  // 设置导出区域的宽度和高度
        height: clippath.height,
        multiplier: 2  // 设置导出图像的分辨率倍数
      });
      this.inputInfo.value = croppedImageData;
    }
    else {
      this.inputInfo.value = '';
    }
  }

 
  
  bindControllerEvent () {
    const controller = this.controller;
    const controllerElementGroupBox = this.dialog.querySelector('.controller-btnGroups');
    const btn = controllerElementGroupBox.querySelectorAll('button');

    // 初始化 Hammer.js
    const hammerManager = new Hammer.Manager(controller.upperCanvasEl);
    const pinch = new Hammer.Pinch();
    const rotate = new Hammer.Rotate();
    const pan = new Hammer.Pan({ direction: Hammer.DIRECTION_ALL });
    // pinch.recognizeWith(pan);
    let scale = false;
    // 添加到 Hammer.js 管理器
    hammerManager.add([pinch, pan]);
    hammerManager.on('pan', (e) => {
      console.log('拖动事件', e);
    });
    hammerManager.on('tap', (e) => {
      console.log('tap', e);
    });
    hammerManager.on('pinchmove', (e) => {
      scale = true;
    });
    hammerManager.on('pinchend', (e) => {
      scale = false;
    });
    hammerManager.on('pinchcancel', (e) => {
      scale = false;
    });
    const debouncePinchin = debounce((e) => {
      console.log('pinchin', e);
      if (scale) {
        this.scale(false, controller);
      }
    }, 16);
    hammerManager.on('pinchin', debouncePinchin);
    const debouncePinchout = debounce((e) => {
      console.log('pinchout', e);
      if (scale) {
        this.scale(true, controller);
      }
    }, 16);
    hammerManager.on('pinchout', debouncePinchout);
    btn.forEach((item) => {
      item.addEventListener('click', (e) => {
        const target = e.target ;
        if(!target) return false;
        if (target.classList.contains('scale')) {
          const scaleResult = target.classList.contains('scaleLarge');
          // scale 为true，并scaleResult为大
          // scale 为false，并scaleResult为小。
          this.scale(scaleResult, controller);
        }
        else if (target.classList.contains('angle')) {
          this.rotate(target.classList.contains('angleLeft'), controller);
        }
        else if (target.classList.contains('clear')) {
          this.inputElement.value = '';
          this.inputElement.classList.remove('hidden');
          controller.clear();
          if (this.dialog.classList.contains('show')) {
            this.dialog.classList.remove('show');
          }
        }
        else if (target.classList.contains('confirm')) {
          const inputElementParent = this.inputElement.parentNode;
          const fileElement = inputElementParent.querySelector('input[type=file][data-input-info-id="' + this.inputInfo.id + '"]');
          const imgDataURL = this.controller.toDataURL();
          const imgElement = inputElementParent.querySelector('.personalize-photo-selected-img[data-input-info-id="' + this.inputInfo.id + '"]');
          const imgBox = inputElementParent.querySelector('.personalize-photo-selected[data-input-info-id="' + this.inputInfo.id + '"]');
          imgElement.src = imgDataURL;
          imgBox.style.display = 'block';
          if (this.dialog.classList.contains('show')) {
            this.dialog.classList.remove('show');
          }
        }
        setTimeout(() => {
          this.controllerClipPath(target.classList.contains('clear'));
        });
      });
    });
  }

  scale (small = false, controller) {
    const obj = controller.getObjects().find(item => item instanceof fabric.Image);

    if ((small && obj.scaleX >= this.maxScale) || (!small && obj.scaleX <= this.minScale)) {
      return false;
    }
    const step = Math.max(obj.scaleX * (1 / 10), obj.scaleY * (1 / 10));
    const scaleX = obj.scaleX;
    const scaleY = obj.scaleY;
    // obj.set({
    //   scaleX: small ? scaleX - step : scaleX + step,
    //   scaleY: small ? scaleY - step : scaleY + step
    // })
    obj.scaleX = Math.max(small ? scaleX + step : scaleX - step);
    obj.scaleY = Math.max(small ? scaleY + step : scaleY - step);

    console.log('small:', small);

    controller.setActiveObject(obj);
    controller.renderAll();
  }
  rotate (left = false, controller) {
    const obj = controller.getObjects().find(item => item instanceof fabric.Image);
    const step = 15;
    const currentAngle = obj.angle;
    obj.angle = left ? currentAngle - step : currentAngle + step; // 将对象顺时针旋转 45 度
    controller.renderAll();
    controller.setActiveObject(obj);

  }
  showController () {
    if (!this.dialog.classList.contains('show')) {
      // this.personalizeForm = currentControllerElement.closest('personalize-form-')
      this.dialog.classList.add('show');
      this.controller.on('mouse:up', (options) => {
        if (options.target) {
          console.log('options:', options);
          // 移除 canvas 画布上的所有非 Image 对象
          this.controllerClipPath();
        }
      });
      this.bindControllerEvent();
    }
  }
  clear () {
    this.controller.clear();
  }
}

if (!customElements.get('frequently-bought')) {
  customElements.define(
    'frequently-bought',
    class FrequentlyBought extends HTMLElement {
      constructor() {
        super();
        this.innerHTML = '';
        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.customize = this.dataset.customize == 'true';
        this.sectionId = this.dataset.sectionId;
        this.shop = this.dataset.shop;
        this.recommendations = [];
        this.previewBox = null;
        this.closeBtn = null;
        this.controller = new ImageController();
        this.canvas = new fabric.Canvas(document.createElement('canvas'), {
          width: 500,
          height: 500,
          crossOrigin:'anonymous',
          backgroundColor: 'white', // 设置背景色为白色
        }); 
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.loadFrequentlyBought();
      }
      loadFrequentlyBought() {
        fetch(`https://cdn.codeblackbelt.com/public/api/v1/frequently-bought-together?productId=${this.productId}&shop=${this.shop}`).then(res => res.body).then(stream => this.parseResponseStream(stream))
        .then(async data => {
          // data.recommendations = [{
          //   handle: 'silver-family-birthstone-cubic-zirconia-heart-necklace-with-4-names',
          //   id: '7711672139946'
          // }, {
          //   handle: 'personalized-photo-christmas-ornaments-for-family-lover',
          //   id: '8249086509226'
          // }]
          if(data.recommendations && data.recommendations.length > 0) { 
            for(let i=0;i<data.recommendations.length;++i) {
              const productData = await fetch(`https://birthstonesjewelry.com/products/${data.recommendations[i].handle}`, {
                headers: {
                  'accept': 'application/json'
                }
              }).then(res => this.parseResponseStream(res.body));
              const product = productData.product || {};
              const personalData = await this.loadPersonal(data.recommendations[i].id);
              const { fontInfo, options, inputInfo, attributes } = personalData.data;
              const inputInfoMap = new Map();
              const customBgMap = {}
              const { host } = window.coolDream;
              const isMobile = window.matchMedia('(max-width: 768px)').matches;
              const width = isMobile ? 400 : 700;
              personalData.attributes.forEach(attr => {
                if (!attr.is_alone) {
                  const info = attr.input_settings_ids.map(cItem => inputInfo.find(children => children.id == cItem));
                 inputInfoMap.set(attr.id, {
                    attribute: attr,
                    info
                  });
                } else { 
                 inputInfoMap.set(attr.id, {
                    attribute: attr,
                    info: attr.alone_settings
                  });
                }
                const img = new Image();
                img.src = `${host}/personalize/product/${attr.custom_bg_name}?width=${width}&height=${width}`;
                img.setAttribute("crossOrigin", 'Anonymous');
          
                customBgMap[attr.id] = img;
              })
              const groupTitle = product.options.map(opt => opt.values[0]).join(' / ');
              const currentVariant = product.variants.find(item => item.title === groupTitle);
              this.recommendations.push({
                ...product,
                selected: false,
                personalData: {
                  productId: product.id,
                  variantSettings: personalData.attributes,
                  customAttribute: attributes,
                  fontInfo, 
                  options, 
                  inputInfoMap,
                  currentVariant,
                  customBgMap
                }
              });
            }
            console.log('recommendations:', this.recommendations);
            
            this.initRecommendations();
            this.initPreview();
            setTimeout(() => {
              this.initEvent();
              this.initPersonalEvent();
            }, 0);
          }
        })
      }
      parseResponseStream(stream, type='json') {
        const reader = stream.getReader(); 
        let chunks = '';
        
        return reader.read().then(function processText({ done, value }) {
          if (done) {
            if(type === 'json') {
              return JSON.parse(chunks); 
            }
            else {
              return chunks;
            }
          }
          chunks += new TextDecoder().decode(value); 
          return reader.read().then(processText);
        });
      }
      loadPersonal(id) {
        const { host, domain } = window.coolDream;
        const originUrl = host + `/api/personalize/product/setting/${id}`;
        const init = {
          method: 'get',
          headers: {
            'user-shop': domain,
            'Content-Type': 'application/json'
          }
        };
        return fetch(originUrl, init).then((response) => response.json())
      }
      initPreview () {
        const html = `
            <div class="personalize-photo-dialog frequently-bought-preview">
              <div class="personalize-preview-close">
                <button type="button" class="clear btn" title="clear">
                  <b class="hidden">clear</b>
                </button>  
              </div> 
              <div class="personalize-preview-wrapper">
                <div class="personalize-canvas-prev swiper-button-prev"> </div> 
                <div class="personalize-preview-box">
                </div>
                <div class="personalize-canvas-next swiper-button-next"> </div> 
              </div>
            </div> 
        `;
        const doc = document.createElement('div');
        doc.className = 'personalize-photo-mask';
        doc.innerHTML = html;
        doc.style.display = 'none';
        document.body.appendChild(doc);
        this.previewBox = doc;
        setTimeout(() => {
          doc.querySelector('.personalize-photo-dialog button.clear')?.addEventListener('click', (e) => {
            doc.style.display = 'none'
          })
          doc.querySelector('.personalize-preview-wrapper .personalize-canvas-prev')?.addEventListener('click', (e) => {
            const box = doc.querySelector('.personalize-preview-box');
            if(box) {
              const width = box.clientWidth || 0;
              const length = box.children.length || 1;
              let scrollLeft = box.scrollLeft || 0;
              if(scrollLeft - width >= 0) {
                scrollLeft = scrollLeft - width
              }
              else {
                scrollLeft = (length-1)*width;
              }
              box.scrollLeft = scrollLeft;
            }
          });
          doc.querySelector('.personalize-preview-wrapper .personalize-canvas-next')?.addEventListener('click', (e) => {
            const box = doc.querySelector('.personalize-preview-box');
            if(box) {
              const width = box.clientWidth || 0;
              const length = box.children.length || 1;
              let scrollLeft = box.scrollLeft || 0;
              if(scrollLeft + width <= (length-1)*width) {
                scrollLeft = scrollLeft + width
              }
              else {
                scrollLeft = 0;
              }
              box.scrollLeft = scrollLeft;
            }
          });
        })
      }

      initRecommendations() {
        let content = '';
        this.recommendations.forEach(v => {
          const defaultImageId = v.variants && v.variants.length > 0 ? v.variants[0].image_id : '';
          const defaultImage = v.images ? v.images.find(item => item.id === defaultImageId)?.src : '';
          const options = this.initOptions(v.options, v.id);
          const personalOptions = this.initPersonalOptions(v.personalData);
          content += `
            <div class="frequently-bought-item">
              <div class="frequently-bought-item-title">
                <a href="/products/${v.handle}" target="blank">
                  <img src="${defaultImage}"/>
                </a>
                <div>
                  <p class="frequently-bought-product-name">${v.title}</p>
                  <p class="frequently-bought-product-price">
                    ${v.variants && v.variants[0].compare_at_price ? 
                      "<span>" + (v.variants && v.variants.length > 0 ? v.variants[0].compare_at_price_currency + v.variants[0].compare_at_price : '') + "</span><span>" + (v.variants && v.variants.length > 0 ? v.variants[0].price_currency + v.variants[0].price : '') + "</span>"
                      :"<span></span><span style='color: inherit'>" + (v.variants && v.variants.length > 0 ? v.variants[0].price_currency + v.variants[0].price : '') + "</span>"}
                  </p>
                </div>
                 <button data-id="${v.id}" class="frequently-bought-checkbox">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon svg-icon-checkbox" style="opacity: 1;">
                    <circle cx="12" cy="12" r="7.63636" fill="none" stroke="currentColor" stroke-width="0.727273"></circle>
                    <path d="M15.4078 9.45767L10.4693 14.3961L8.41166 12.3384" stroke="var(--colors-background, #ffffff)" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                 </button>
              </div>
              <div class="frequently-bought-item-props hidden" id="frequently-bought-${v.id}-props">
                ${options}
                <div id="frequently-bought-personal-options-${v.id}">
                  ${personalOptions}
                </div>
              </div>
              <form method="post" id="product-form-${v.id}" action="/cart/add" class="frequently-bought-item-form" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" data-product-id="${v.id}">
                <button type="submit" class="buy-btn button button--full-width hidden" data-product-id="${v.id}" name="add">
                  <span>Buy Now</span>
                  <div class="loading__spinner hidden">
                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="product-id" value="${v.id}">
              </form>  
            </div>
          `;
        });
        this.innerHTML = `
          <div class="frequently-bought-box">
            <div class="frequently-bought-title">FREQUENTLY BOUGHT TOGETHER</div>
            <div class="frequently-bought-list">
              ${content}
            </div>
          </div>
          `
      }

      initOptions(options, productId) {
        let content = '';
        options.forEach(v => {
          const valueOptions = v.values.map(item => `<option value="${item}">${item}</option>`)
          content += `
            <div class="product-form__input">
              <label class="form__label" for="frequently-bought-options-${v.id}">${v.name}</label>
              <div class="select">
                <select name="options[${v.name}]" class="select__select frequently-bought-options" id="frequently-bought-options-${v.id}" data-product-id="${productId}" form="product-form-${productId}">
                  ${valueOptions}
                </select>
              </div>
            </div>
          `
        })
        return content;
      }
      
      renderPersonalOptions(recommendItem) {
        const personalOptions = this.initPersonalOptions(recommendItem.personalData);
        this.querySelector(`#frequently-bought-personal-options-${recommendItem.id}`).innerHTML = personalOptions;
        setTimeout(() => {
          this.initPersonalEvent();
        }, 0);
      }
      initPersonalOptions(personalData) {
        const frag = document.createDocumentFragment();
        const activeInputInfos = personalData.variantSettings.filter(item => {
          return item.product_variants_id.includes(`gid://shopify/ProductVariant/${personalData.currentVariant.id}`);
        });
        activeInputInfos.forEach((item) => {
          const info = personalData.inputInfoMap.get(item.id)
          const parser = new DOMParser();
          const inputHtml = parser.parseFromString(this.createGroupElement(info, item.id, personalData), "text/html");
          frag.appendChild(inputHtml.querySelector('.personalizeBox_group'));
        });
        const content = document.createElement('section');
        content.classList.add('personalize-content');
        const gem = frag.querySelectorAll('.personalizeBox-gem');
        if (gem.length >= 2) {
          content.classList.add('personalizeBox-gems-more');
        }
        content.appendChild(frag);
        if(activeInputInfos.length > 0) {
          const previewButton = document.createElement('button');
          previewButton.dataset.productId = personalData.productId;
          previewButton.innerText = 'Preview';
          previewButton.classList.add('preview-btn');
          previewButton.classList.add('button');
          previewButton.classList.add('button--full-width');
          content.appendChild(previewButton);
        }
        return content.outerHTML;
      }

      createGroupElement (info, attributeId, personalData) {
        const fontInfo = personalData.fontInfo;
        const mergeFront = info.attribute.merge_front_options ? true : false;
        const lastIndex = info.info.findLastIndex(v => v.input_type === 0 && v.font_group_id > 0);
        let defaultFont;
        const result = info.info.map((item, index) => {
          item.id = item.id ? item.id : new Date().getTime() + Math.random()
            .toString(36)
            .substring(2, 10);
          // 是否合并字体选项
          const withFontOption = mergeFront ? (index == lastIndex ? true : false) : true;
          if (withFontOption  && item.input_type === 0 && fontInfo) {
            item.font_group_id = info.info.find(item => item.input_type === 0 && item.font_group_id)?.font_group_id;    
            const defaultFontId = fontInfo.font_group.find(v => v.id === item.font_group_id)?.font_ids[0];
            defaultFont = fontInfo.fontList.find(item => item.id === defaultFontId);
          }
          return this.createElement(index, item, withFontOption, personalData, attributeId);
        }).join('\n');
        return `
          <section data-attribute-id="${attributeId}" data-product-id="${personalData.productId}" data-merge-front="${info.attribute.merge_front_options}"  class="personalizeBox_group" open ${mergeFront ? 'style="--personalize-fontFamily:' + defaultFont?.name + '"' : ''}>
            ${result}
          </section>
        `;
      }
      createElement (index, elem, withFontOption = true, personalData, attributeId) {
        const fontInfo = personalData.fontInfo;
        const { group_name, required, word_count, font_group_id, input_type } = elem;
        let fontSlt;
        let firstFont;
        if (input_type === 0 && font_group_id > 0 && withFontOption && fontInfo) {
          const font_group = fontInfo.font_group.find(item => item.id === font_group_id);
    
          fontSlt = this.createFontElement(font_group, group_name, personalData);
          firstFont = fontInfo.fontList.find(item => item.id === font_group.font_ids[0]);
        }
        const { inputHtml } = this.switchHTML(index, elem, personalData, attributeId);
        return `
          <section  class="personalizeBox ${input_type == 2 ? 'personalizeBox-gem' : ''}" ${input_type === 0 && font_group_id > 0 && withFontOption ? "style=--personalize-fontFamily:" + firstFont.name : ''}>
           <legend class="form__label">
              ${required ? '<span class="required">*</span>' : ''} 
              <span style="display: inline-block;width: calc(100% - 90px)">${group_name}</span>
              <span class="attribute-mark" > 
              </span> <span class="word_count">${word_count ? word_count + 'characters' : ''}</span>
            </legend>
            ${inputHtml}
            ${required ? '<span class="error">This input is required!</span>' : ''}
          </fieldset>
          ${input_type === 0 && font_group_id > 0 && withFontOption ? fontSlt : ''}
          </section>
        `;
      }

      createFontElement (font_group, input_name, personalData) {
        const fontInfo = personalData.fontInfo;
        const { group_name, font_ids } = font_group;
        const fontList = font_ids.map(item => fontInfo.fontList.find(cItem => cItem.id === item));
        let options = '';
        fontList.forEach(item => {
          options += `<option class="${item.name}" value="${item.file_url}">${item.name}</option>`;
        });
        return `
          <section class="personalizeBox" ${font_ids.length === 1 ? 'style="height:0;visibility:hidden;"' : ""}>
          <legend class="form__label"> ${group_name} </legend>
          <fieldset class="js product-form__input">
            <select id="frequently--${this.productId}__main-${group_name.replace(' ', '_')}-${input_name.replace(' ', '_')}-select" name="properties[${input_name}_font]" class="personalize_input swatch-input" value="" >
                ${options}
            </select>
          </fieldset>
          </section>
        `;
      }

      switchHTML (index, data, personalData, attributeId) {
        const customAttribute = personalData.customAttribute;
        const { group_name, required, word_count, input_type, options_ids, id, color, text_type } = data;
        const group_name_str = group_name.replace(' ', '-');
        let inputHtml;
        switch (input_type) {
          case 0:
            inputHtml = text_type === 1 ?
              `<input style="--input-color: ${color}" ${required ? 'required' : ''} type="text"   maxlength="${word_count}"  id="frequently--${personalData.productId}__main-${index}-${group_name_str}-input" name="properties[${group_name_str}]" class="personalize_input swatch-input" value="" form="product-form-${personalData.productId}"  data-input-info-id="${id}" data-attribute-id="${attributeId}" />` :
              `<textarea style="--input-color: ${color}" ${required ? 'required' : ''}    maxlength="${word_count}" rows=${3}  id="frequently--${personalData.productId}__main-${index}-${group_name_str}-input" name="properties[${group_name_str}]" class="personalize_input swatch-input" value="" form="product-form-${personalData.productId}"  data-input-info-id="${id}" data-attribute-id="${attributeId}"></textarea>`;
            break;
          case 1:
              inputHtml = `
              <div class="personalize-photo-box">
                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="upload-icon-vjzGD tw-icon-static tw-h-8 tw-w-8 tw-text-gray-4 tw-mb-1 customeow-icon customeow-icon-icon-image-photo-plus-solid" width="20" height="20"><path d="M1 5.25C1 4.65326 1.23705 4.08097 1.65901 3.65901C2.08097 3.23705 2.65326 3 3.25 3H16.75C17.0455 3 17.3381 3.0582 17.611 3.17127C17.884 3.28434 18.1321 3.45008 18.341 3.65901C18.5499 3.86794 18.7157 4.11598 18.8287 4.38896C18.9418 4.66194 19 4.95453 19 5.25V9.5H13.5C11.9944 9.5 10.6831 10.3318 10.0006 11.5609L6.53 8.091C6.38937 7.95055 6.19875 7.87166 6 7.87166C5.80125 7.87166 5.61063 7.95055 5.47 8.091L2.5 11.06V14.75C2.5 15.164 2.836 15.5 3.25 15.5H9.5V17H3.25C2.65326 17 2.08097 16.7629 1.65901 16.341C1.23705 15.919 1 15.3467 1 14.75V5.25ZM12 7C12 7.26522 11.8946 7.51957 11.7071 7.70711C11.5196 7.89464 11.2652 8 11 8C10.7348 8 10.4804 7.89464 10.2929 7.70711C10.1054 7.51957 10 7.26522 10 7C10 6.73478 10.1054 6.48043 10.2929 6.29289C10.4804 6.10536 10.7348 6 11 6C11.2652 6 11.5196 6.10536 11.7071 6.29289C11.8946 6.48043 12 6.73478 12 7Z" fill="#d1d5db" fill-rule="evenodd" clip-rule="evenodd"></path><path d="M16.25 12C16.25 11.5858 15.9142 11.25 15.5 11.25C15.0858 11.25 14.75 11.5858 14.75 12V14.25H12.5C12.0858 14.25 11.75 14.5858 11.75 15C11.75 15.4142 12.0858 15.75 12.5 15.75H14.75V18C14.75 18.4142 15.0858 18.75 15.5 18.75C15.9142 18.75 16.25 18.4142 16.25 18V15.75H18.5C18.9142 15.75 19.25 15.4142 19.25 15C19.25 14.5858 18.9142 14.25 18.5 14.25H16.25V12Z" fill="#e60044" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                <div>Photo</div>
                <div>(1/1)</div>
                <input  ${required ? 'required' : ''} type="file"  id="frequently--${personalData.productId}__main-${index}-${group_name_str}-input" name="properties[${group_name_str}]" class="personalize-photo-input personalize_input swatch-input" value="" form="product-form-${personalData.productId}"  data-input-info-id="${id}" data-attribute-id="${attributeId}" accept=".jpg, .jpeg, .png"/>
                <div class="personalize-photo-selected"  data-input-info-id="${id}">         
                  <img src="" class="personalize-photo-selected-img" data-input-info-id="${id}"/>
                  <span class="clear-btn" data-input-info-id="${id}"></span>
                </div>
              </div>`;
            break;
          case 2:
            const gemOptions = customAttribute.find(item => item.id === options_ids);
            const gemOptionsClass = gemOptions.group_name.replaceAll(' ', '-');
            const birthstone = document.getElementById('gem-personalize-product').content.querySelector(`.${gemOptionsClass}`);
            birthstone.querySelectorAll('input').forEach(item => {
              const Id = item.getAttribute('id');
              item.removeAttribute('checked');
              item.setAttribute('id', `${Id}-${group_name_str}`);
              item.setAttribute('data-input-info-id', id);
              item.setAttribute('data-product-id', personalData.productId);
              item.setAttribute('name', `properties[${group_name_str}]`);
              item.setAttribute('form', `product-form-${personalData.productId}`);
              if (required) {
                item.setAttribute('required', true);
              }
            });
            birthstone.querySelectorAll('label').forEach(item => {
              const Id = item.getAttribute('for');
              item.setAttribute('for', `${Id}-${group_name_str}`);
            });
            inputHtml = birthstone.outerHTML;
            break;
          case 3:
            const options = customAttribute.find(item => item.id === options_ids);
            inputHtml = this.createAttributes(options, group_name_str, personalData);
            break;
    
        }
        return { inputHtml };
      }

      createAttributes (elem, group_name_str, personalData) {
        const { options } = elem;
    
        let optionsHtml = '';
    
        options.forEach((item, index) => {
          optionsHtml += `
            <option  value="${item}">${item}</option>
          `;
        });
    
        const optionsBoxStr = `
        <select  id="frequently--${personalData.productId}__main-${group_name_str}-option-select" name="properties[${group_name_str}]" class="personalize_input swatch-input" value=""  form="product-form-${personalData.productId}">
            ${optionsHtml}
        </select>
        `;
        return optionsBoxStr;
      }
      
      initEvent() {
        const checkboxs = this.querySelectorAll('.frequently-bought-item .frequently-bought-checkbox');
        Array.prototype.slice.call(checkboxs).forEach(button => {
          button.addEventListener('click', (e) => {
            const id = button.dataset.id;
            const recommendItem = this.recommendations.find(v => v.id == id);
            if(recommendItem) {
              if(recommendItem.selected) {
                recommendItem.selected = false;
                button.querySelector('circle').setAttribute('fill', 'none');
                this.querySelector(`#frequently-bought-${id}-props`)?.classList.add('hidden');
                this.querySelector(`.buy-btn[data-product-id="${id}"]`)?.classList.add('hidden');
              }
              else {
                recommendItem.selected = true;
                button.querySelector('circle').setAttribute('fill', 'currentColor');
                this.querySelector(`#frequently-bought-${id}-props`)?.classList.remove('hidden');
                this.querySelector(`.buy-btn[data-product-id="${id}"]`)?.classList.remove('hidden');
              }
            }
          })
        });

        const buyButtons = this.querySelectorAll('.frequently-bought-item .buy-btn');
        Array.prototype.slice.call(buyButtons).forEach(button => {
          button.addEventListener('click', async (e) => {
            e.preventDefault();
            const productId = button.dataset.productId;
            const recommendItem = this.recommendations.find(v => v.id == productId);
            const personalOptions = this.querySelector(`#frequently-bought-personal-options-${productId}`)?.querySelectorAll('input.personalize_input, textarea.personalize_input') || [];
            const activeInputInfos = recommendItem.personalData.variantSettings.filter(item => {
              return item.product_variants_id.includes(`gid://shopify/ProductVariant/${recommendItem.personalData.currentVariant.id}`);
            });
            let formData = {};
            const config = {method: 'post'}
            // 包含定制内容时，使用FormData传参
            if(activeInputInfos.length > 0) {
              const form = this.querySelector(`.frequently-bought-item-form[data-product-id="${productId}"]`);
              formData = new FormData(form);
              formData.append('id', recommendItem.personalData.currentVariant.id);
              console.log('personalOptions:', personalOptions);
              Array.prototype.slice.call(personalOptions).forEach(opt => {
                console.log('opt:', opt.type);
                const attributeId = parseInt(opt.dataset.attributeId);
                if(attributeId) {
                  const inputInfo = recommendItem.personalData.inputInfoMap.get(attributeId);
                  const inputInfoId = opt.dataset.inputInfoId;
                  console.log('inputInfo:', inputInfo, inputInfoId);
                  const inputItem = inputInfo.info.find(v => v.id == inputInfoId)
                  if(inputItem && inputItem.value) {
                    if(opt.type === 'file') {
                      formData.set(opt.name, base64ToFile(inputItem.value, opt.name));
                    }
                    else {
                      formData.set(opt.name, inputItem.value || '');
                    }
                  }
                }
                else {
                  formData.set(opt.name, opt.value);
                }           
              });
              let i = 0;
              for(const item of activeInputInfos) {
                const canvas = await this.renderCanvas(recommendItem.personalData, item.id);
                const url = canvas.toDataURL({ format: 'png', multiplier: 1.5, quality: 1 });
                const file = await fetch(url).then(response => response.blob()).then(blob => new File([blob], 'canvasImage.jpeg', { type: 'image/jpeg' }));
                formData.append(`properties[preview${i ? i : ''}]`,  file);
                i++
              }
              config.body = formData;
              if(this.cart) {
                formData.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);  
              }
            }
            else {
              config.headers = {
                'Content-Type': 'application/json'
              }
              formData = {
                items: [{
                  id: recommendItem.personalData.currentVariant.id,
                  quantity: 1
                }],
                sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : undefined,
                sections_url: this.cart ? window.location.pathname : undefined
              }
              config.body = JSON.stringify(formData);
            }
            //if(!this.customize && activeInputInfos.length === 0) {
            button.querySelector('.loading__spinner').classList.remove('hidden');
            button.setAttribute('aria-disabled', true);
            this.addToCart(config).then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'frequently-form',
                  productVariantId: this.variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
                return;
              } 
              else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'frequently-form',
                productVariantId: this.variantId,
                cartData: response,
              });
              setTimeout(() => {
                this.cart.classList.contains('is-empty') &&
                  this.cart.classList.remove('is-empty');
                this.cart.renderContents(response);
              }, 0)
            }).finally(() => {
              button.removeAttribute('aria-disabled');
              button.querySelector('.loading__spinner').classList.add('hidden');
            });
            // 主商品定制或者副商品定制时单件逐次加购
            // else {
            //   const mainProductBuyButton = document.querySelector(`#custom_product-${this.sectionId}`)
            //   const mainProductForm = document.querySelector('product-form');
            //   if(mainProductBuyButton) {
            //     mainProductBuyButton.click();
            //     mainProductForm?.addEventListener('AddToCartComplete', () => {
            //       this.addToCart(config).then((response) => {
            //         if(this.cart) {
            //           setTimeout(() => {
            //             this.cart.classList.contains('is-empty') &&
            //               this.cart.classList.remove('is-empty');
            //             this.cart.renderContents(response);
            //           }, 200);
            //         }
            //       })
            //     }, { once: true })
            //   }
            // }
          })
        });

        const options = this.querySelectorAll('select.frequently-bought-options');
        Array.prototype.slice.call(options).forEach(element => {
          element.addEventListener('change', (e) => {
            const productId = element.dataset.productId;
            const recommendItem = this.recommendations.find(v => v.id == productId);
            const allOptions = this.querySelectorAll(`select.frequently-bought-options[data-product-id="${productId}"`);
            const groupTitle = Array.prototype.slice.call(allOptions).map(v => v.value).join(' / ');
            const currentVariant = recommendItem.variants.find(item => item.title === groupTitle);
            recommendItem.personalData.currentVariant = currentVariant;
            this.renderPersonalOptions(recommendItem);
          });
        });

      }

      addToCart(config) {
        console.log('config:', config);
        const originUrl = `${window.Shopify.routes.root}cart/add.js`;
        return fetch(originUrl, config)
          .then((response) => response.json())  
      }

      initPersonalEvent() {
        const debounceInput = debounce((e) => {
          const target = e.target;
          const box = target.closest('.personalizeBox_group');
          const mergeFront = parseInt(box.dataset.mergeFront);
          const attributeId = parseInt(box.dataset.attributeId);
          const productId = parseInt(box.dataset.productId);
          const personalizeBox = target.closest('.personalizeBox');
          const productData = this.recommendations.find(v => v.id == productId);
          const currentAttributeInfo = productData.personalData.inputInfoMap.get(attributeId)?.info;
          const inputInfoItem = currentAttributeInfo.find(item => target.dataset.inputInfoId == item.id);
          if (target.maxLength > 0) {
            const count = target.maxLength - target.value.length;
            personalizeBox.querySelector('.word_count').textContent = `${count}characters`;
          }
          inputInfoItem.value = target.value;
  
          if(inputInfoItem.font_group_id !== 0) {
            if (!mergeFront) {
              inputInfoItem.fontFamily = personalizeBox.style.getPropertyValue('--personalize-fontFamily');
            }
            else {
              inputInfoItem.fontFamily = box.style.getPropertyValue('--personalize-fontFamily');
            }
          }
          if (target.type == 'file') {
            this.controller.initController(target, inputInfoItem);
            !target.classList.contains('hidden') && target.classList.add('hidden');
          }
        }, 100);

        const inputElem = this.querySelectorAll('input.personalize_input, textarea.personalize_input');
        inputElem.forEach(item => {
          item.addEventListener('input', debounceInput);
        });

        const radioElem = this.querySelectorAll('input[type="radio"]');
        radioElem.forEach(
          item => {
            item.addEventListener('change', function (e) {
              console.log('radio', e);
              const target = e.target;
              radioChange.call(this, target);
            }.bind(this));
          }
        );
        function radioChange (target) {
          const attributeId = parseInt(target.closest('.personalizeBox_group').dataset.attributeId);
          const productId = parseInt(target.dataset.productId);
          const productData = this.recommendations.find(v => v.id == productId);
          const currentAttributeInfo = productData.personalData.inputInfoMap.get(attributeId)?.info;
          const inputInfo = currentAttributeInfo.find(item => target.dataset.inputInfoId == item.id);
          const img = target.nextElementSibling.children[0].src;
          inputInfo.value = img;
          inputInfo.label = target.value;
          const box = target.closest('.personalizeBox-gem');
          box.querySelector('.form__label .attribute-mark').textContent = `: ${target.value}`;
        }

        const onClearBtnClick = (e) => {
          const target = e.target;
          const inputInfoId = target.dataset.inputInfoId;
          const fileElement = this.querySelector('input[type=file][data-input-info-id="' + inputInfoId + '"]');
          const imgElement = this.querySelector('.personalize-photo-selected-img[data-input-info-id="' + inputInfoId + '"]');
          const imgBox = this.querySelector('.personalize-photo-selected[data-input-info-id="' + inputInfoId + '"]');
          fileElement.value = '';
          fileElement.classList.remove('hidden');
          this.controller.clear();
          imgElement.src = '';
          imgBox.style.display = 'none';
        };
        const clearPhotoBtns = this.querySelectorAll('.clear-btn');
        clearPhotoBtns.forEach(btn => {
          btn.addEventListener('click', onClearBtnClick);
        });

        const previewBtns = this.querySelectorAll('.preview-btn');
        Array.prototype.slice.call(previewBtns).forEach(btn =>  {
          btn?.addEventListener('click', async (e) => {
            const fragment = document.createDocumentFragment();    
            const productId = e.target.dataset.productId;
            const recommendItem = this.recommendations.find(v => v.id == productId);
            const { personalData } = recommendItem;
            const activeInputInfos = personalData.variantSettings.filter(item => {
              return item.product_variants_id.includes(`gid://shopify/ProductVariant/${personalData.currentVariant.id}`);
            });
            for(const item of activeInputInfos) {
              const canvas = await this.renderCanvas(recommendItem.personalData, item.id);
              const img = document.createElement('img');
              img.crossOrigin="anonymous";
              img.src = canvas.toDataURL({ format: 'png', multiplier: 1.5, quality: 1 });
              fragment.appendChild(img); 
            }
            this.previewBox.querySelector('.personalize-preview-box').innerHTML = '';
            this.previewBox.querySelector('.personalize-preview-box')?.appendChild(fragment);
            this.previewBox.style.display = 'block'; 
            if(activeInputInfos.length < 2) {
              this.previewBox.querySelector('.personalize-canvas-prev').style.display = 'none';
              this.previewBox.querySelector('.personalize-canvas-next').style.display = 'none';
            }
            else {
              this.previewBox.querySelector('.personalize-canvas-prev').style.display = 'block';
              this.previewBox.querySelector('.personalize-canvas-next').style.display = 'block';
            }
          })
        })
      }

      async renderCanvas (personalData, attributeId) {
        const canvas = this.canvas;
        canvas?.clear();
        const width = canvas.width;
        const height = canvas.height;
        const inputInfoList = personalData.inputInfoMap.get(attributeId).info;
  
        const custom_bg_img = personalData.customBgMap[attributeId];
  
        const bgInstance = new fabric.Image(custom_bg_img,
          {
            selectable: false,
            crossOrigin: 'anonymous'
          }
        );
  
        const originalWidth = bgInstance.width;
        const originalHeight = bgInstance.height;
        const scaleRatioWidth = width / originalWidth;
        const scaleRatioHeight = height / originalHeight;
        const scaleRatio = Math.max(scaleRatioWidth, scaleRatioHeight);
  
        bgInstance.scaleToWidth(originalWidth * scaleRatio);
        bgInstance.scaleToHeight(originalHeight * scaleRatio);
  
        bgInstance.moveTo(1);
        canvas.add(bgInstance);
        bgInstance.sendToBack();
        window.dispatchEvent(new Event('personalizeChange'));
        
        const inputInfos = [];
        let textColor = '';
        inputInfoList.forEach(v => {
          if(v.group_name === 'T Shirt Text Color' || v.group_name === 'Text Color for Blanket' || v.group_name === 'Text Color for Throw Pillow') {
            const textColorMap = {
              Black:'#000000',
              White:'#ffffff',
              Gray:'#dfe0e2',
              'Dark Gray':'#7b7f82',
              'Cobalt Blue':'#163f9b',
              Navy:'#0c2аба',
              Red:'#d83b34',
              Pink:'#f57cc1',
              Purple:'#9a67f2',
              Green:'#30a324',
              'Light Blue':'#51d1ff',
              Yellow:'#fec70b',
              Orange:'#ff9c2c',
              Turquoise:'#07a1d7',
            }
            textColor = textColorMap[v.label]
          }
          else if(v.group_name === 'Text Color for Cap' || v.group_name === 'Text Color for Stocking') {
            const textColorMap = {
              Orange:'#ec8534',
              Green:'#32a37c',
              'Dark Blue':'#1d206c',
              White:'#ffffff',
              'Fluorescent Pink':'#f26a7f',
              'Dark Red':'#77292d',
              'Light Pink':'#f3dcdf',
              Silver:'#989999',
              Red:'#c42023',
              Gold:'#eee6b5',
              Black:'#000000',
              Purple:'#4e16a0',
            }
            textColor = textColorMap[v.label]
          }
          else if(v.group_name === 'Text Color for Ornament') {
            const textColorMap = {
              Green:'#009944',
              White:'#ffffff',
              Red:'#e60012',
              Black:'#231815',
            }
            textColor = textColorMap[v.label]
          }
          // else if(v.input_type === 1 && v.group_name.indexOf('Snowflake') > -1 && v.value) {
          //   // 特定上传图加雪花图层
          //   inputInfos.push(v);
          //   inputInfos.push({
          //     ...v,
          //     group_name: 'Snow Bg',
          //     value: this.snowBg,
          //     image_layer: 0
          //   })
          // }
          else {
            inputInfos.push(v); 
          }
        });
        const element = inputInfos.map(async function (inputInfo) {
          const { width_percent, height_percent, x_position_percent, y_position_percent, input_type, image_layer, shape, font_curved = 0 } = inputInfo;
          let boxX = width * x_position_percent,
            boxY = height * y_position_percent,
            boxWidth = width * width_percent,
            boxHeight = height * height_percent;
          let element;
          const targetWidth = boxWidth;
          const targetHeight = boxHeight;
          // 图片
          if (input_type == 1 || input_type == 2) {
            element = await this.switchFabricObject(inputInfo, boxWidth, boxHeight, boxX, boxY, width/400);
            // 计算调整比例
            // 设置裁剪图像的大小
            element.scaleToWidth(input_type == 2 ? Math.max(targetWidth, targetHeight) : targetWidth, true);
            element.set({ angle: inputInfo.angle });
  
            if (shape === 2) {
              element.clipPath = new fabric.Circle({
                radius: Math.max(targetWidth, targetHeight) / 2,
                fill: 'transparentCorners',
                absolutePositioned: true,
                hasControls: false,
                selectable: false,
                left: boxX,
                top: boxY,
  
              });
            } else {
              element.clipPath = new fabric.Rect({
                width: boxWidth,
                height: boxHeight,
                fill: 'transparentCorners',
                absolutePositioned: true,
                hasControls: false,
                selectable: false,
                // originX: 'center', originY: 'center',
                left: boxX,
                top: boxY,
                angle: inputInfo.angle,
              });
            }
          } else {
            element = this.switchFabricObject(inputInfo, boxWidth, boxHeight, boxX, boxY, width/400, textColor, font_curved); 
            console.log('element', element.width, element.height, targetWidth, targetHeight, inputInfo.fontFamily);
          }
          if (input_type == 1 || input_type == 2) {
            // 0文件在顶层，1文件在图层底部
            // image_layer ? element.sendToBack() : element.bringToFront();
            element.input_type = input_type;
            element.image_layer = image_layer;
            // console.log('elememt', inputInfo.group_name, inputInfo.image_layer, element)
  
          }
          return element;
          // canvas.add(circle);
  
        }.bind(this));
        return Promise.all(element)
        .then(results => {
          results.forEach(item => {
            console.log('item:', item);
            canvas.add(item);
            if (item.input_type == 1 || item.input_type == 2) {
              item.image_layer ? item.sendToBack() : item.bringToFront();
              // item.bringToFront();
            }
          });
        })
        .then(() => {
          return canvas;
        });
      }
      switchFabricObject (inputInfo, width, height, boxX, boxY, scaleRatio, textColor, fontCurved) {
        const { font_size, value = '', fontFamily, color, input_type, id, angle } = inputInfo;
        if (input_type) {
          return new Promise((resolve, reject) => {
            fabric.Image.fromURL(value, function (img) {
              img.set({
                id: `controllerClipPath${id}`,
                left: boxX,
                top: boxY,
                hasControls: false,
                selectable: false,
                crossOrigin: 'anonymous'
              });
              resolve(img);
            }, { crossOrigin: 'anonymous' });
          });
  
        } else {
          console.log('fontFamily', width, height, fontFamily);
          return new fabric.Textbox(value, {
            width: width,
            height: height,
            splitByGrapheme: true,
            left: boxX,
            top: boxY,
            textAlign: 'center',
            fontSize: Math.max(font_size * scaleRatio , 12),
            lineHeight: 1,
            fontFamily: fontFamily || 'sans-serif',
            fill: textColor || color,
            hasControls: false,
            selectable: false,
            angle,
            path: fontCurved ? (() => {
              const startX = 0;
              const startY = 0;
              const cx1 = startX + width/3;
              const cy1 = startY - height * fontCurved / 10;
              const cx2 = startX + width*2/3;
              const cy2 = startY - height * fontCurved / 10;
              const endX = startX + width;
              const endY = startY;
  
              const d = `M ${startX},${startY} C ${cx1},${cy1} ${cx2},${cy2} ${endX},${endY}`;
              return new fabric.Path(d, { fill: '', stroke: '', selectable: false, evented: false });
            })() : undefined
          });
        }
      }
      
    }
  );
}


/**
 * Convert a Base64 string (dataURL) to a File object.
 * @param {string} dataurl - The data URL string (e.g. "data:image/png;base64,....")
 * @param {string} filename - Desired file name, including extension (e.g. "image.png")
 * @returns {File}
 */
function base64ToFile(dataurl, filename) {
  // Split the input to get the mime type and the base64 content
  const arr = dataurl.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : '';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {type: mime});
}
